import { canPreShipOrder } from "@/services/api/jinritemai";
import GlobalStore from "@/store";
import { InjectBaseModalProps } from "@/hooks/Modal/ModalStore";
import { openUrl } from "@/utils";
import { Modal } from "antd";
import React, { useEffect } from "react";
import "./index.less";
import ShopType from "@/enum/ShopType";
import { observer } from "mobx-react-lite";
import "./index.less";
import { useGlobalStore } from "@/store/hooks";

const STORAGE_KEY = "__DOUDIAN_PRE_SHIP_GUIDE_MODAL_2026_04_24__";

const SUPPORT_SHOP_TYPES = [ShopType.DOUDIAN, ShopType.DOUDIAN_IOP, ShopType.DOUDIAN_SUPPLIER];
const GUIDE_URL = "https://qw15p3s8hv.feishu.cn/wiki/B8USwHcyTiHhIVk5GTWcruCVnGn";
const POSTER_URL =
    "https://p3-ecom-fe.byteimg.com/tos-cn-i-w59vco1lho/a72e58aeb20a3f08037f0bcabc0707ae.png~tplv-w59vco1lho-png.png";

interface DouDianPreShipGuideModalProps extends InjectBaseModalProps {}

const DouDianPreShipGuideModal: React.FC<DouDianPreShipGuideModalProps> = observer((props) => {
    const { open, onCancel } = props;

    const handleOpenGuide = () => {
        onCancel();
        openUrl(GUIDE_URL);
        localStorage.setItem(STORAGE_KEY, "1");
    };

    return (
        <Modal
            className="doudian-pre-ship-guide-modal"
            open={open}
            onCancel={() => {
                onCancel();
            }}
            width={540}
            footer={null}
            title={null}
            mask={{ closable: false }}
            destroyOnHidden
            centered
        >
            <div className="doudian-pre-ship-guide-modal__poster">
                <img
                    className="doudian-pre-ship-guide-modal__image"
                    src={POSTER_URL}
                    alt="抖店3小时内取号发货弹窗"
                    width={540}
                    height={395}
                />
                <div className="doudian-pre-ship-guide-modal-subtitle">
                    单店现货订单结算GMV平均可提升
                    <svg
                        width="13"
                        height="15"
                        viewBox="0 0 13 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ transform: "translateY(3px)" }}
                    >
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M6.08398 0.239636C6.39892 -0.0799496 6.91447 -0.0798075 7.22949 0.239636L12.1484 5.23378C12.6489 5.74219 12.2887 6.60194 11.5752 6.60194H8.875C8.46259 9.94178 7.07642 14.7631 0 14.7631C1.86313 14.2904 4.82577 11.5158 4.56152 6.60194H1.73828C1.02499 6.60182 0.664937 5.74218 1.16504 5.23378L6.08398 0.239636Z"
                            fill="url(#paint0_linear_795_7429)"
                        ></path>
                        <defs>
                            <linearGradient
                                id="paint0_linear_795_7429"
                                x1="3.82808"
                                y1="14.2585"
                                x2="-3.42887"
                                y2="3.46571"
                                gradientUnits="userSpaceOnUse"
                            >
                                <stop stop-color="#FF002F"></stop>
                                <stop offset="0.947744" stop-color="#FFA600"></stop>
                            </linearGradient>
                        </defs>
                    </svg>
                </div>

                <div className="doudian-pre-ship-guide-modal-desc">
                    消费者下单支付完成后，商家<span style={{ fontWeight: 500, margin: "0 5px" }}>3小时</span>
                    内取物流单号并回传运单号完成发货操作可降低消费者发货前退款率，整体提升店铺的结算GMV。
                </div>

                <div className="doudian-pre-ship-guide-modal-button-wrapper">
                    <a
                        className="button-left"
                        onClick={() => {
                            handleOpenGuide();
                        }}
                    >
                        查看教程
                    </a>

                    <a
                        className="button-right"
                        onClick={() => {
                            localStorage.setItem(STORAGE_KEY, "1");

                            onCancel();
                        }}
                    >
                        不再提示
                    </a>
                </div>
            </div>
        </Modal>
    );
});

let show = false;

export async function ensureDouDianPreShipDialog(globalStore: typeof GlobalStore, shopId: number) {
    try {
        if (localStorage.getItem(STORAGE_KEY)) {
            return;
        }

        const currentUserShop = globalStore.shopMapping.get(shopId);

        if (!currentUserShop || !SUPPORT_SHOP_TYPES.includes(currentUserShop.type)) {
            return;
        }

        const res = await canPreShipOrder(shopId);

        if (!res?.canPreShipOrder) return;
        if (show) return;
        globalStore.modalStore.openModal(DouDianPreShipGuideModal);

        show = true;
    } catch {}
}

export function useShowDouDianPreShipDialog(shopId: number) {
    const globalStore = useGlobalStore();

    useEffect(() => {
        if (show) return;
        if (!shopId) return;
        const shop = globalStore.shopMapping.get(shopId);
        if (!shop) return;
        if (!SUPPORT_SHOP_TYPES.includes(shop.type)) return;

        ensureDouDianPreShipDialog(globalStore, shopId);
    }, [shopId]);
}
